import React, { FC, memo } from 'react';
import { DivWrapper, DivNumber, SpanText } from './styles';
import clsx from 'clsx';

type TProps = {
  index: number;
  text: string;
  isActive: boolean;
  onClick: (index: number) => void;
};

const StepButton: FC<TProps> = ({ index, text, isActive, onClick }) => (
  <DivWrapper onClick={() => onClick(index)}>
    <DivNumber className={clsx({ ['active']: isActive })}>{index + 1}</DivNumber>
    <SpanText className={clsx({ ['active']: isActive })}>{text}</SpanText>
  </DivWrapper>
);

export default memo(StepButton);
